import request from 'utils/request'

export const getMCAXS571InitRequest = () =>
  request({
    url: '/MCAXS571/init',
    method: 'post',
  })
